import React from "react";
import { ColorResult, RGBColor, SketchPicker } from "react-color";

export const BLACK_COLOR_RGBA = {
  r: 0,
  g: 0,
  b: 0,
  a: 1,
};
interface ColorPillProps {
  onChange?: (color: ColorResult) => void;
  defaultColor?: string;
}

const stringRGBAToRGB = (color?: string): RGBColor => {
  if (!color) return BLACK_COLOR_RGBA;
  const [r, g, b, a] = color
    .replace("rgba(", "")
    .replace(")", "")
    .split(",")
    .map((x) => Number(x.trim()));
  return {
    r,
    g,
    b,
    a,
  };
};

export const ColorPill = ({ onChange, defaultColor }: ColorPillProps) => {
  const [displayColorPicker, setDisplayColorPicker] = React.useState(false);
  const [color, setColor] = React.useState<RGBColor>(stringRGBAToRGB(defaultColor));

  const handleClick = () => {
    setDisplayColorPicker((pv) => !pv);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (color: ColorResult) => {
    onChange && onChange(color);
    setColor(color.rgb);
  };

  return (
    <div>
      <div
        style={{
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <div
          style={{
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
          }}
        />
      </div>
      {displayColorPicker ? (
        <div
          style={{
            position: "absolute",
            zIndex: "2",
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
            }}
            onClick={handleClose}
          />
          <SketchPicker color={color} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  );
};
